import { NotificationView } from "@/data/types";
import Avatar from "@/views/Components/Avatar";
import WishImage from "../Wishlist/WishImage";
import { generatePath, Link } from "react-router";
import { RoutePaths } from "@/views/routes";

export function FriendAddedWish({
  notification,
}: {
  notification: NotificationView;
}) {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col items-center gap-0 md:flex-row md:gap-4">
        <Link
          className="flex flex-row items-center gap-4"
          to={generatePath(RoutePaths.specificWishlist, {
            wishlistId: notification.wishlistId || "",
          })}
        >
          <Avatar uid={notification.sourceUserId} />
          <div className="H6 wish-light-primary">
            {notification.sourceUserDisplayName}
          </div>
        </Link>
        <div className="ml-3 md:m-0">added new wishes</div>
      </div>
      <div className="ml-14 mt-4">
        {notification.wishes?.map((w) => (
          <Link
            to={generatePath(RoutePaths.wishlistItem, {
              wishlistId: notification.wishlistId || "",
              wishId: w.wishId || "",
            })}
            key={w.wishId}
          >
            <WishImage imageLink={w.wishImageUrl || ""} small />
          </Link>
        ))}
      </div>
    </div>
  );
}
